import RosterBuilderApi from 'api/activityRosterBuilderApi';
import { timelineToRosterBuilder } from 'selectors/timeline';
import { message } from 'antd';
import { ROSTERBUILDER_TIMELINE } from './actionTypes';

const actionType = ROSTERBUILDER_TIMELINE;

// ========================================
// ROSTER BUILDER TIMELINE
// ========================================

export const requestInFlight = () => ({
  type: actionType.REQUEST_IN_FLIGHT
});

export const setUsers = users => ({
  type: actionType.SET_USERS,
  users,
});

export const newRosterBuilderTimeline = () => ({
  type: actionType.NEW_ROSTERBUILDER
});

const loadRosterBuilderTimelineSuccess = data => ({
  type: actionType.LOADED_ROSTERBUILDER_SUCCESS,
  data
});
const loadRosterBuilderTimelineFailure = data => ({
  type: actionType.LOADED_ROSTERBUILDER_FAILURE,
  data
});

export const loadRosterBuilderTimeline = id => (dispatch) => {
  dispatch(requestInFlight());
  return RosterBuilderApi.getActivityRosterBuilder({ id })
    .then(
      (response) => {
        const itemData = JSON.parse(JSON.stringify(response.data));
        dispatch(loadRosterBuilderTimelineSuccess(itemData));
        return itemData;
      },
      (error) => {
        dispatch(loadRosterBuilderTimelineFailure(error));
        throw error;
      }
    );
};

const saveRosterBuilderTimelineSuccess = rosterBuilder => ({
  type: actionType.SAVE_ROSTERBUILDER_SUCCESS,
  data: rosterBuilder
});
const saveRosterBuilderTimelineFailure = rosterBuilder => ({
  type: actionType.SAVE_ROSTERBUILDER_FAILURE,
  data: rosterBuilder
});

export const saveRosterBuilderTimeline = (rosterBuilderId, activities, groups) => (dispatch) => {
  dispatch(requestInFlight());
  return RosterBuilderApi.saveActivityRosterBuilderActivities(rosterBuilderId, timelineToRosterBuilder(activities, groups))
    .then(
      (response) => {
        if (response.status === 207) {
          message.warning(response.data);
        }
        // Dispatch a successful save
        const itemData = response.data;
        dispatch(saveRosterBuilderTimelineSuccess(itemData));

        // Reload the roster builder
        dispatch(loadRosterBuilderTimeline(rosterBuilderId));
        return itemData;
      },
      (error) => {
        dispatch(saveRosterBuilderTimelineFailure(error));
        throw error;
      }
    );
};

const addToRosterSuccess = value => ({
  type: actionType.SAVE_ADDTOROSTER_SUCCESS,
  data: value
});
const addToRosterFailure = value => ({
  type: actionType.SAVE_ADDTOROSTER_FAILURE,
  data: value
});

/* eslint-disable implicit-arrow-linebreak */
export const addRosterBuilderToRoster = (rosterBuilderId, addToRosterBody) =>
  dispatch => RosterBuilderApi.addRosterBuilderToRoster(rosterBuilderId, addToRosterBody)
  .then((response) => {
    if (response.status === 207) {
      message.warning(response.data);
    }
    dispatch(addToRosterSuccess(response.data));
    return response;
  })
  .catch((error) => {
    dispatch(addToRosterFailure(error));
    throw error;
  });
/* eslint-disable implicit-arrow-linebreak */

// ========================================
// ROSTER BUILDER TIMELINE ACTIVITIES
// ========================================

export const addTimelineActivity = (activity, group, time, createActivityCount = 1, hoursBetween = 24) => ({
  type: actionType.ADD_ACTIVITY_TO_TIMELINE,
  activity,
  group,
  time,
  createActivityCount,
  hoursBetween
});

// @param {*} changes EG: "{"isStartTimeChange":false,"timeDelta":0}"
// @param {*} items
// @param {*} maxTimelineDays
//
export const updateTimelineActivities = items => ({
  type: actionType.UPDATE_ACTIVITIES,
  items
});

export const deleteTimelineActivity = () => ({
  type: actionType.DELETE_TIMELINE_ACTIVITY
});

export const selectTimelineActivities = itemIds => ({
  type: actionType.SELECT_TIMELINE_ACTIVITIES,
  ids: itemIds
});

// @param {*} changes EG: "{"rowChangeDelta":0,"timeDelta":150}" //min
// @param {*} items EG: "[{"title":"Crew Roster","key":1349,"row":1,"start":"2001-01-03T23:00:00.000Z","end":"2001-01-04T11:00:00.000Z","color":"#4a90e2"},{"title":"Crew Roster","key":1350,"row":1,"start":"2001-01-04T23:00:00.000Z","end":"2001-01-05T11:00:00.000Z","color":"#4a90e2"}]"
// @param {*} maxTimelineDays
//
export const moveTimelineActivities = (changes, items) => ({
  type: actionType.MOVE_ACTIVITIES,
  changes,
  items
});

// @param {*} changes EG: "{"isStartTimeChange":false,"timeDelta":0}"
// @param {*} items
// @param {*} maxTimelineDays
//
export const resizeTimelineActivities = (changes, items) => ({
  type: actionType.RESIZE_ACTIVITIES,
  changes,
  items
});

export const updatePinnedActivities = activities => ({
  type: actionType.UPDATE_PINNED_ACTIVITIES,
  activities
});

export const reorderTimelineGroup = (fromGroupId, toGroupId) => ({
  type: actionType.REORDER_GROUP,
  fromGroupId,
  toGroupId
});

export const deleteTimelineGroup = groupId => ({
  type: actionType.DELETE_ENTIRE_GROUP,
  groupId
});

// Users Actions - Start
export const assignUserToPlaceHolder = (user, placeHolderGroupId) => ({
  type: actionType.ASSIGN_USER_TO_PLACEHOLDER,
  user,
  placeHolderGroupId
});

export const removeAssignedUserFromPlaceHolder = placeHolderGroupId => ({
  type: actionType.REMOVE_ASSIGNED_USER,
  placeHolderGroupId
});

export const reorderAssignedUser = (fromGroupId, toGroupId) => ({
  type: actionType.REORDER_ASSIGNED_USER,
  fromGroupId,
  toGroupId
});

export const swapUserWithPlaceholder = (fromGroupId, toGroupId) => ({
  type: actionType.SWAP_USER_WITH_PLACEHOLDER,
  fromGroupId,
  toGroupId
});

export const reorderUsersCyclic = () => ({
  type: actionType.CYCLIC_ORDER_SHIFT_USERS
});

// Users Actions - End
